/* JD Flavor Index — organic hover-and-discover.
 * 1. Refines each flavor's pour colour from its name (category tint is the floor).
 * 2. On fine pointers, a single shared "tasting peek" card follows the cursor with
 *    the flavour's bottle, tasting headline, pairings and rating. Keyboard focus
 *    anchors it to the focused name. Touch devices skip the card (the inline
 *    tasting line + colour bead carry the discovery there).
 */
(function () {
  var idx = document.querySelector('.jd-flavor-index');
  if (!idx) return;

  /* Name keyword -> "r, g, b". First match wins; specific before generic. */
  var COLORS = [
    [/blood\s*orange/, '196, 78, 42'],
    [/espresso|coffee/, '58, 40, 30'],
    [/chocolate|cocoa/, '74, 44, 34'],
    [/bourbon|whiskey|barrel/, '120, 76, 40'],
    [/blueberry/, '70, 64, 128'],
    [/black\s*garlic/, '60, 54, 50'],
    [/cherry/, '140, 38, 52'],
    [/cranberry/, '140, 34, 52'],
    [/raspberry|strawberry/, '150, 42, 70'],
    [/pomegranate/, '140, 30, 58'],
    [/fig/, '96, 54, 86'],
    [/coconut/, '150, 140, 110'],
    [/mango/, '212, 150, 48'],
    [/passion\s*fruit/, '204, 150, 40'],
    [/peach/, '214, 140, 96'],
    [/pear/, '150, 156, 92'],
    [/ghost\s*pepper/, '170, 52, 36'],
    [/habanero/, '204, 96, 36'],
    [/jalape|jalapeno/, '96, 128, 52'],
    [/lemon|meyer|lime/, '196, 160, 52'],
    [/basil|herb|tuscan/, '90, 120, 52'],
    [/truffle/, '74, 60, 44'],
    [/garlic|sesame|parmesan/, '150, 140, 108'],
    [/blood|red|rossa/, '150, 42, 48'],
    [/white|coconut|special\s*reserve/, '150, 132, 96'],
    [/lambrusco|rose|wine/, '120, 36, 54']
  ];

  var links = idx.querySelectorAll('.jd-flavor-index__link');
  links.forEach(function (a) {
    var t = a.textContent.toLowerCase();
    for (var i = 0; i < COLORS.length; i++) {
      if (COLORS[i][0].test(t)) { a.style.setProperty('--flavor', COLORS[i][1]); break; }
    }
  });

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!fine) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Build the single shared card. */
  var card = document.createElement('div');
  card.className = 'jd-fpeek';
  card.setAttribute('aria-hidden', 'true');
  card.innerHTML =
    '<div class="jd-fpeek__media"><img alt="" loading="lazy" decoding="async"></div>' +
    '<div class="jd-fpeek__body">' +
      '<p class="jd-fpeek__headline"></p>' +
      '<div class="jd-fpeek__rating"></div>' +
      '<p class="jd-fpeek__pairs"></p>' +
    '</div>';
  document.body.appendChild(card);
  var elImg = card.querySelector('.jd-fpeek__media img');
  var elHead = card.querySelector('.jd-fpeek__headline');
  var elRate = card.querySelector('.jd-fpeek__rating');
  var elPairs = card.querySelector('.jd-fpeek__pairs');

  function stars(rating, max) {
    var r = Math.round(parseFloat(rating));
    var m = Math.round(parseFloat(max)) || 5;
    if (!r) return '';
    var s = '';
    for (var i = 0; i < m; i++) s += i < r ? '★' : '☆';
    return s;
  }

  var current = null;

  function populate(a) {
    var head = a.getAttribute('data-headline');
    var pairs = a.getAttribute('data-pairs');
    var img = a.getAttribute('data-img');
    var rating = a.getAttribute('data-rating');

    if (head) { elHead.textContent = head; elHead.style.display = ''; }
    else { elHead.textContent = a.textContent.trim(); elHead.style.display = ''; }

    if (img) {
      elImg.src = img;
      elImg.alt = a.getAttribute('data-alt') || '';
      card.classList.remove('jd-fpeek--noimg');
    } else {
      elImg.removeAttribute('src');
      card.classList.add('jd-fpeek--noimg');
    }

    if (rating) {
      /* stars only — drop the numeric count so the card stays a quick taste read, not a stat block */
      elRate.textContent = stars(rating, a.getAttribute('data-rating-max'));
      elRate.style.display = '';
    } else {
      elRate.textContent = '';
      elRate.style.display = 'none';
    }

    if (pairs) {
      elPairs.innerHTML = '<b>Drizzle on</b>' + pairs.replace(/</g, '&lt;');
      elPairs.style.display = '';
    } else {
      elPairs.textContent = '';
      elPairs.style.display = 'none';
    }

    var c = getComputedStyle(a).getPropertyValue('--flavor').trim();
    if (c) card.style.setProperty('--fp-flavor', c);
  }

  /* Anchor the card DIRECTLY BELOW the hovered name so it reads as a drawer sliding
     out from under that item — not a card flying in from a screen corner. Position is
     set via top/left (fixed-positioned); the entry slide+fade lives entirely in the
     CSS transform, so the two never interfere. If there's no room below the item we
     flip it above and emerge upward instead (.is-above swaps origin + motion vector). */
  var GAP = 8;   /* breathing room between the item and the card edge */
  var PAD = 12;  /* keep-off-the-viewport-edge margin */
  function placeToEl(a) {
    var r = a.getBoundingClientRect();
    var w = card.offsetWidth, h = card.offsetHeight;

    /* Horizontal: left-align to the item, then clamp inside the viewport. */
    var nx = r.left;
    if (nx + w + PAD > window.innerWidth) nx = window.innerWidth - w - PAD;
    if (nx < PAD) nx = PAD;

    /* Vertical: default below the item's bottom edge. Flip above only if the card
       would overflow the bottom AND there's more room above than below. */
    var roomBelow = window.innerHeight - r.bottom;
    var roomAbove = r.top;
    var below = !(roomBelow < h + GAP + PAD && roomAbove > roomBelow);
    var ny = below ? r.bottom + GAP : r.top - h - GAP;
    if (ny < PAD) ny = PAD;
    if (ny + h + PAD > window.innerHeight) ny = window.innerHeight - h - PAD;

    card.classList.toggle('is-above', !below);
    card.style.left = Math.round(nx) + 'px';
    card.style.top = Math.round(ny) + 'px';
  }

  function show(a) {
    current = a;
    populate(a);
    /* measure (content set) then position before revealing — avoids a first-frame jump */
    placeToEl(a);
    card.classList.add('is-on');
    card.setAttribute('aria-hidden', 'false');
  }
  function hide() {
    current = null;
    card.classList.remove('is-on');
    card.setAttribute('aria-hidden', 'true');
  }

  /* Hover intent: a small dwell before the card appears so sweeping across the
     grid doesn't fire a storm of cards. Quicker to swap once one is already open
     (the reader is deliberately moving name to name), full beat from rest. */
  var OPEN_DELAY = 150, SWITCH_DELAY = 75;
  var timer = null;
  function cancelTimer() { if (timer) { clearTimeout(timer); timer = null; } }
  function intend(a) {
    cancelTimer();
    if (reduce) { show(a); return; }
    var delay = card.classList.contains('is-on') ? SWITCH_DELAY : OPEN_DELAY;
    timer = setTimeout(function () { timer = null; show(a); }, delay);
  }

  idx.addEventListener('pointerover', function (e) {
    var a = e.target.closest('.jd-flavor-index__link');
    if (!a) return;
    if (a === current) { cancelTimer(); return; } /* back on the open name — drop any pending switch */
    intend(a);
  });
  idx.addEventListener('pointerout', function (e) {
    var a = e.target.closest('.jd-flavor-index__link');
    if (!a) return;
    if (!e.relatedTarget || !e.relatedTarget.closest('.jd-flavor-index__link')) {
      cancelTimer();
      hide();
    }
  });

  /* Keyboard parity — intentional focus, so no dwell delay. */
  idx.addEventListener('focusin', function (e) {
    var a = e.target.closest('.jd-flavor-index__link');
    if (!a) return;
    cancelTimer();
    show(a);
  });
  idx.addEventListener('focusout', function (e) {
    var a = e.target.closest('.jd-flavor-index__link');
    if (a) { cancelTimer(); hide(); }
  });
  window.addEventListener('scroll', function () { cancelTimer(); if (current) hide(); }, { passive: true });
})();
